module.exports = __webpack_public_path__ + "static/media/FOTO 3.6.b3f9a20a.png";